export enum FinanceStatusEnum {
  SELECT = "Select",
  PRE_APPROVED = "Pre-approved",
  APPLICATION_IN_PROGRESS = "Application in progress",
  EXPLORING_MY_OPTIONS = "Exploring my options",
  CASH_BUYER = "Cash buyer",
}
